import { render, staticRenderFns } from "./post-media.vue?vue&type=template&id=170e0d60&scoped=true&"
import script from "./post-media.vue?vue&type=script&lang=js&"
export * from "./post-media.vue?vue&type=script&lang=js&"
import style0 from "./post-media.vue?vue&type=style&index=0&id=170e0d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e0d60",
  null
  
)

export default component.exports